import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { RoleApi } from 'api';
import { RoleScope } from 'types';

function useDelete(scope: RoleScope) {
  const queryClient = useQueryClient();
  return useAuthMutation((id: number) => RoleApi.del(scope, id), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useDelete;
